import createIcon from '@/lib/create-icon'

const SearchQuestionIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 28' fill='none'>
    <path
      d='M24.5001 24.5L20.0376 20.0375M13.4157 13.4085V13.167C13.4157 12.376 13.9045 11.9478 14.3945 11.6188C14.8728 11.2968 15.3524 10.8768 15.3524 10.1022C15.3524 9.03233 14.4855 8.16667 13.4168 8.16667C12.3482 8.16667 11.4802 9.03117 11.4802 10.101M13.2131 3.5C7.85727 3.5 3.5 7.73836 3.5 12.9494C3.5 18.1605 7.85727 22.4 13.2131 22.4C18.5677 22.4 22.925 18.1605 22.925 12.9494C22.925 7.73836 18.5677 3.5 13.2131 3.5Z'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M13.4154 16.7417C13.3186 16.7417 13.2404 16.8198 13.2416 16.9167C13.2416 17.0135 13.3198 17.0917 13.4166 17.0917C13.5134 17.0917 13.5916 17.0135 13.5916 16.9167C13.5916 16.8198 13.5134 16.7417 13.4154 16.7417'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>,
  'SearchQuestionIcon'
)

export default SearchQuestionIcon
